import React from 'react';
import { Icon } from '../../components/Icon/Icon';
import { t } from '../../locales/translate';
import { SwipeButton } from './SwipeButton';
import { ScannerState } from './TicketScanner';
import { CheckoutAlert } from './CheckoutAlert';
import { useCheckoutAlert } from '../../model/ticketScanner';
import './ScanResult.css';

interface Props {
  state: ScannerState;
  checkInTime?: string | null;
  checkInLocation: string | null;
  onCheckout: () => void;
}

export function ScanResult({
  state = 'initial',
  checkInTime = t.page.ticketScanner.checkIn,
  checkInLocation = t.page.ticketScanner.gate,
  onCheckout,
}: Props): JSX.Element | null {
  const [isAlertVisible, setIsAlertVisible] = React.useState(false);

  const [isAlertDisabled] = useCheckoutAlert();

  if (state === 'scanning') {
    return null;
  }
  return (
    <>
      {(state === 'initial' || state === 'ready') && (
        <div className="scan-result scan-result--initial">
          <Icon name="camera-off" />
          <p>zZ</p>
        </div>
      )}

      {state === 'success' && (
        <div className="scan-result scan-result--success">
          <Icon name="valid" />
          <p>{t.page.ticketScanner.valid}</p>
        </div>
      )}

      {state === 'error' && (
        <div className="scan-result scan-result--error">
          <Icon name="invalid" />
          <p>{t.page.ticketScanner.invalid}</p>
        </div>
      )}

      {state === 'checked' && (
        <div className="scan-result scan-result--checked">
          {isAlertVisible && (
            <CheckoutAlert
              onCheckout={() => {
                onCheckout();
                setIsAlertVisible(false);
              }}
            />
          )}
          <div className="scan-result__header">
            <Icon name="door" />
            <p>{t.page.ticketScanner.checked}</p>
          </div>
          <div className="scan-result__ticket">
            <div className="scan-result__ticket-half">
              <p className="scan-result__ticket-label">{t.page.ticketScanner.checkIn}</p>
              <p className="scan-result__ticket-value">{checkInTime}</p>
            </div>
            <span className="scan-result__ticket-separator"></span>
            <div className="scan-result__ticket-half">
              <p className="scan-result__ticket-label">{t.page.ticketScanner.gate}</p>
              <p className="scan-result__ticket-value">{checkInLocation}</p>
            </div>
          </div>
          <div className="scan-result__button-wrapper">
            <SwipeButton
              onSwipeFinish={() => {
                if (isAlertDisabled) {
                  onCheckout();
                } else {
                  setIsAlertVisible(true);
                }
              }}
              buttonText={t.page.ticketScanner.checkout}
            />
          </div>
        </div>
      )}
    </>
  );
}
